<template>
  <div class="main">
    <div
      class="main__others"
      v-if="otherData.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in otherData"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span
            class="value"
            :class="{alarm:alarm.includes(item.value)}"
          >{{item.value}}</span>
        </li>
      </ul>
    </div>

    <div
      class="main__others"
      v-if="controlStatus.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in controlStatus"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span
            class="value"
            :class="{alarm:alarm.includes(item.value)}"
          >{{item.value}}</span>
        </li>
      </ul>
    </div>

    <div
      class="main__others"
      v-if="errorStatus.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in errorStatus"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span
            class="value"
            :class="{alarm:alarm.includes(item.value)}"
          >{{item.value}}</span>
        </li>
      </ul>
    </div>

    <div
      class="main__others"
      v-if="pointStatus.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in pointStatus"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span
            class="value"
            :class="{alarm:alarm.includes(item.value)}"
          >{{item.value}}</span>
        </li>
      </ul>
    </div>

    <div
      class="main__list"
      v-if="protectStatus.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in protectStatus"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span
            class="value"
            :class="{alarm:alarm.includes(item.value)}"
          >{{item.value}}</span>
        </li>
      </ul>
    </div>

    <div
      class="main__list"
      v-if="warnStatus.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in warnStatus"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span
            class="value"
            :class="{alarm:alarm.includes(item.value)}"
          >{{item.value}}</span>
        </li>
      </ul>
    </div>

    <div
      class="main__list"
      v-if="batteryFlagList.length>0"
    >
      <ul>
        <li
          :title="'电压告警状态位'+index+':'+(item === 0?'正常':item === 1?'报警':'--')"
          v-for="(item, index) in batteryFlagList"
          :key="index"
        >
          <span class="title">电压告警状态位{{index}}: </span>
          <span
            class="value"
            :class="{alarm:item === 1}"
          >{{item === 0?"正常":item === 1?"报警":'--'}}</span>
        </li>
      </ul>
    </div>

    <div
      class="main__list"
      v-if="tempFlagList.length>0"
    >
      <ul>
        <li
          :title="'电芯温度告警状态位'+index+':'+(item === 0?'正常':'异常')"
          v-for="(item, index) in tempFlagList"
          :key="index"
        >
          <span class="title">电芯温度告警状态位{{index}}: </span>
          <span
            class="value"
            :class="{alarm:item != 0}"
          >{{item === 0?"正常":"异常"}}</span>
        </li>
      </ul>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      otherData: [
        { title: "均衡状态1", value: "--" },
        { title: "均衡状态2", value: "--" },
        { title: "电芯个数", value: "--" },
        { title: "放电电流告警", value: "--" },
        { title: "充电电流告警", value: "--" },
        { title: "电池组id", value: "--" },
        { title: "总电压告警", value: "--" }
      ],
      //电压告警状态位列表
      batteryFlagList: [],
      //电芯温度告警状态位列表
      tempFlagList: [],
      //控制状态
      controlStatus: [
        { title: "蜂鸣器告警控制", value: "--" },
        { title: "充电限流控制", value: "--" },
        { title: "LED告警控制", value: "--" }
      ],
      //故障状态
      errorStatus: [
        { title: "充电MOS故障", value: "--" },
        { title: "放电MOS故障", value: "--" },
        { title: "电芯故障", value: "--" },
        { title: "温度传感器故障（NTC）", value: "--" },
        { title: "采样故障", value: "--" }
      ],
      pointStatus: [
        { title: "ACin", value: "--" },
        { title: "CFET指示	", value: "--" },
        { title: "充电器反接指示", value: "--" },
        { title: "DFET指示", value: "--" },
        { title: "加热膜指示", value: "--" },
        { title: "限流指示", value: "--" },
        { title: "使用Pack供电指示", value: "--" }
      ],
      protectStatus: [
        { title: "充电高温保护（电芯）", value: "--" },
        { title: "充电低温保护（电芯）", value: "--" },
        { title: "充电过流保护", value: "--" },
        { title: "放电高温保护", value: "--" },
        { title: "放电低温保护（电芯）", value: "--" },
        { title: "放电过流保护", value: "--" },
        { title: "环境高温保护", value: "--" },
        { title: "环境低温保护（电芯）", value: "--" },
        { title: "Fully（充满）", value: "--" },
        { title: "单体过放保护", value: "--" },
        { title: "单体过压保护", value: "--" },
        { title: "MOS高温保护", value: "--" },
        { title: "短路保护", value: "--" },
        { title: "总压过压保护", value: "--" },
        { title: "总压过放保护", value: "--" }
      ],
      warnStatus: [
        { title: "充电高温告警（电芯）", value: "--" },
        { title: "充电低温告警（电芯）", value: "--" },
        { title: "充电过流告警", value: "--" },
        { title: "放电高温告警", value: "--" },
        { title: "放电低温告警", value: "--" },
        { title: "放电过流告警", value: "--" },
        { title: "环境高温告警", value: "--" },
        { title: "环境低温告警", value: "--" },
        { title: "低电量告警", value: "--" },
        { title: "单体低压告警", value: "--" },
        { title: "单体过压告警", value: "--" },
        { title: "MOS高温告警", value: "--" },
        { title: "总压低压告警", value: "--" },
        { title: "总压过压告警", value: "--" }
      ],
      alarm: ["报警", "屏蔽", "故障", "告警", "无", "OFF", "未使用"]
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        const {
          balanceFlagOne,
          balanceFlagTwo,
          batteryCount,
          batteryFlagList,
          controlStatus,
          dischargeElectricFlag,
          errorStatus,
          pileElectricFlag,
          pileId,
          pileVoltageFlag,
          pointStatus,
          protectStatus,
          tempFlagList,
          warnStatus
        } = val;
        this.otherData = [
          {
            title: "均衡状态1",
            value: balanceFlagOne != undefined ? balanceFlagOne : "--"
          },
          {
            title: "均衡状态2",
            value: balanceFlagTwo != undefined ? balanceFlagTwo : "--"
          },
          {
            title: "电芯个数",
            value: batteryCount != undefined ? batteryCount : "--"
          },
          {
            title: "放电电流告警",
            value:
              dischargeElectricFlag === 0
                ? "正常"
                : dischargeElectricFlag === 1
                ? "报警"
                : "--"
          },
          {
            title: "充电电流告警",
            value:
              pileElectricFlag === 0
                ? "正常"
                : pileElectricFlag === 1
                ? "报警"
                : "--"
          },
          { title: "电池组id", value: pileId != undefined ? pileId : "--" },
          {
            title: "总电压告警",
            value: pileVoltageFlag === 0 ? "正常" : "报警"
          }
        ];

        this.controlStatus = [
          {
            title: "蜂鸣器告警控制",
            value: this.controlStatusFormat(
              controlStatus != undefined ? controlStatus.buzzer : "--"
            )
          },
          {
            title: "充电限流控制",
            value: this.controlStatusFormat(
              controlStatus != undefined ? controlStatus.chargeLimiting : "--"
            )
          },
          {
            title: "LED告警控制",
            value: this.controlStatusFormat(
              controlStatus != undefined ? controlStatus.ledWarn : "--"
            )
          }
        ];

        this.errorStatus = [
          {
            title: "充电MOS故障",
            value: this.errorStatusFormat(
              errorStatus != undefined ? errorStatus.chargeMos : "--"
            )
          },
          {
            title: "放电MOS故障",
            value: this.errorStatusFormat(
              errorStatus != undefined ? errorStatus.dichargeMos : "--"
            )
          },
          {
            title: "电芯故障",
            value: this.errorStatusFormat(
              errorStatus != undefined ? errorStatus.electricCore : "--"
            )
          },
          {
            title: "温度传感器故障（NTC）",
            value: this.errorStatusFormat(
              errorStatus != undefined ? errorStatus.nTC : "--"
            )
          },
          {
            title: "采样故障",
            value: this.errorStatusFormat(
              errorStatus != undefined ? errorStatus.sampling : "--"
            )
          }
        ];

        this.pointStatus = [
          {
            title: "ACin",
            value:
              pointStatus && pointStatus.aCin === 1
                ? "有"
                : pointStatus && pointStatus.aCin === 0
                ? "无"
                : "--"
          },
          {
            title: "CFET指示	",
            value:
              pointStatus && pointStatus.cfet === 1
                ? "ON"
                : pointStatus && pointStatus.cfet === 0
                ? "OFF"
                : "--"
          },
          {
            title: "充电器反接指示",
            value:
              pointStatus && pointStatus.chargerReverse === 1
                ? "反接"
                : pointStatus && pointStatus.chargerReverse === 0
                ? "无"
                : "--"
          },
          {
            title: "DFET指示",
            value:
              pointStatus && pointStatus.dfet === 1
                ? "ON"
                : pointStatus && pointStatus.dfet === 0
                ? "OFF"
                : "--"
          },
          {
            title: "加热膜指示",
            value:
              pointStatus && pointStatus.heatingFilm === 1
                ? "ON"
                : pointStatus && pointStatus.heatingFilm === 0
                ? "OFF"
                : "--"
          },
          {
            title: "限流指示",
            value:
              pointStatus && pointStatus.limiting === 1
                ? "ON"
                : pointStatus && pointStatus.limiting === 0
                ? "OFF"
                : "--"
          },
          {
            title: "使用Pack供电指示",
            value:
              pointStatus && pointStatus.packSupply === 1
                ? "Pack供电"
                : pointStatus && pointStatus.packSupply === 0
                ? "未使用"
                : "--"
          }
        ];

        this.protectStatus = [
          {
            title: "充电高温保护（电芯）",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.chargeHighTemp : "--"
            )
          },
          {
            title: "充电低温保护（电芯）",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.chargeLowTemp : "--"
            )
          },
          {
            title: "充电过流保护",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.chargeOver : "--"
            )
          },
          {
            title: "放电高温保护",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.dischargeHighTemp : "--"
            )
          },
          {
            title: "放电低温保护（电芯）",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.dischargeLowTemp : "--"
            )
          },
          {
            title: "放电过流保护",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.dischargeOver : "--"
            )
          },
          {
            title: "环境高温保护",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.environmentHighTemp : "--"
            )
          },
          {
            title: "环境低温保护（电芯）",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.environmentLowTemp : "--"
            )
          },
          {
            title: "Fully（充满）",
            value:
              protectStatus && protectStatus.fully === 1
                ? "充满"
                : protectStatus && protectStatus.fully === 0
                ? "无"
                : "--"
          },
          {
            title: "单体过放保护",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.monomerOverDischarge : "--"
            )
          },
          {
            title: "单体过压保护",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.monomerOverVoltage : "--"
            )
          },
          {
            title: "MOS高温保护",
            value: protectStatus ? protectStatus.mosHighTemp : "--"
          },
          {
            title: "短路保护",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.shortCircuit : "--"
            )
          },
          {
            title: "总压过压保护",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.totalOverVoltage : "--"
            )
          },
          {
            title: "总压过放保护",
            value: this.protectStatusFormat(
              protectStatus ? protectStatus.voltageOverDischarge : "--"
            )
          }
        ];

        this.batteryFlagList = batteryFlagList || [];
        this.tempFlagList = tempFlagList || [];

        this.warnStatus = [
          {
            title: "充电高温告警（电芯）",
            value: this.dataFormat(
              warnStatus ? warnStatus.chargeHighTemp : "--"
            )
          },
          {
            title: "充电低温告警（电芯）",
            value: this.dataFormat(warnStatus ? warnStatus.chargeLowTemp : "--")
          },
          {
            title: "充电过流告警",
            value: this.dataFormat(warnStatus ? warnStatus.chargeOver : "--")
          },
          {
            title: "放电高温告警",
            value: this.dataFormat(
              warnStatus ? warnStatus.dischargeHighTemp : "--"
            )
          },
          {
            title: "放电低温告警",
            value: this.dataFormat(
              warnStatus ? warnStatus.dischargeLowTemp : "--"
            )
          },
          {
            title: "放电过流告警",
            value: this.dataFormat(warnStatus ? warnStatus.dischargeOver : "--")
          },
          {
            title: "环境高温告警",
            value: this.dataFormat(
              warnStatus ? warnStatus.environmentHighTemp : "--"
            )
          },
          {
            title: "环境低温告警",
            value: this.dataFormat(
              warnStatus ? warnStatus.environmentLowTemp : "--"
            )
          },
          {
            title: "低电量告警",
            value: this.dataFormat(warnStatus ? warnStatus.lowPower : "--")
          },
          {
            title: "单体低压告警",
            value: this.dataFormat(
              warnStatus ? warnStatus.monomerLowVoltage : "--"
            )
          },
          {
            title: "单体过压告警",
            value: this.dataFormat(
              warnStatus ? warnStatus.monomerOverVoltage : "--"
            )
          },
          {
            title: "MOS高温告警",
            value: this.dataFormat(warnStatus ? warnStatus.mosHighTemp : "--")
          },
          {
            title: "总压低压告警",
            value: this.dataFormat(
              warnStatus ? warnStatus.totalLowVoltage : "--"
            )
          },
          {
            title: "总压过压告警",
            value: this.dataFormat(
              warnStatus ? warnStatus.totalOverVoltage : "--"
            )
          }
        ];
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    dataFormat(data) {
      if (data === 1) {
        return "告警";
      } else if (data === 0) {
        return "正常";
      }
      return "--";
    },
    protectStatusFormat(data) {
      if (data === 1) {
        return "保护";
      } else if (data === 0) {
        return "无";
      }

      return data || "--";
    },
    controlStatusFormat(data) {
      if (data === 1) {
        return "使能";
      } else if (data === 0) {
        return "屏蔽";
      }
      return data || "--";
    },
    errorStatusFormat(data) {
      if (data === 1) {
        return "故障";
      } else if (data === 0) {
        return "正常";
      }
      return data || "--";
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  &__others {
    padding: 10px 0;
    display: flex;
    flex: 1;
    border-bottom: 1px solid rgb(216, 217, 218);
    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 25%;
        padding: 10px 0;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .title {
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
  &__list {
    padding: 10px 0;
    display: flex;
    flex: 1;
    border-bottom: 1px solid rgb(216, 217, 218);
    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 25%;
        padding: 10px 0;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .title {
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
.alarm {
  color: red !important;
}
</style>